import { useAppDispatch } from "../store/hooks/StoreHooks";
import {
    getCopyProjectExistsList,
    getCopyProjects,
    getGlobalTemplate,
    getMyProjects,
    getPinProjects,
    getRecentProjects,
    getRemoveMyProjects,
    gettingOtherProjects,
    patchCaseDetails,
    postCreateNewCase,
    shareWithCustomer,
    getSharedCases,
    updatePinStatus,
    makeUpdateProjectStatus,
    updateSelectedProject,
    loadProjectStatusCount,
    loadRecentCustomerFeedback,
    fetchHasUserProjectAccess
} from "../store/dashboard/ProjectsSlice";
import {
    copyMyProjectsExistsPayload,
    copyMyProjectsPayload,
    GetMyProjectsPayload,
    MyProjects,
    UpdatePinStatusPayload,
} from "../models/Myprojects";
import { ProjectDetails } from "../store/model/MyProjects";
import { gettingCustomerDetails, gettingCustomerDetailsById, gettingWellDeatils, gettingWellDetailsById, setExistingCustomerState, setExistingWellState, setWellDetailsByIdState, } from "../store/calculation/calculation-input/ProjectTabSlice";
import { CustomerDetailsPayload, WellDetailsPayload } from "../store/model/calculations/calculation";
import { ShareWithCustomerModel } from "../models/ShareWithCustomerModel";

const useProjectFacade = () => {
    const dispatch = useAppDispatch();

    const loadProjects = (payload: GetMyProjectsPayload) => {
        return dispatch(getMyProjects(payload));
    };

    const loadPinProject = () => {
        return dispatch(getPinProjects());
    };

    const togglePinStatus = (payload: UpdatePinStatusPayload) => {
        return dispatch(updatePinStatus(payload));
    };

    const loadRecentProjects = () => {
        return dispatch(getRecentProjects());
    };

    const loadOtherProject = (payload: GetMyProjectsPayload) => {
        return dispatch(gettingOtherProjects(payload));
    };

    const copyMyProjects = async (payload: copyMyProjectsPayload) => {
        return await dispatch(getCopyProjects(payload));
    };

    const triggerShareWithCustomer = async (params: ShareWithCustomerModel) => {
        return await dispatch(shareWithCustomer(params));
    };

    const triggerGetSharedCases = async (params: string) => {
        return await dispatch(getSharedCases(params));
    };

    const triggerUpdateProjectStatus = async (params: { id: string, status: number, updateTree?: boolean }) => {
        return await dispatch(makeUpdateProjectStatus(params));
    };

    const copyMyProjectExists = async (payload: copyMyProjectsExistsPayload) => {
        return await dispatch(getCopyProjectExistsList(payload));
    };

    const removeMyProjects = async (payload: any) => {
        return await dispatch(getRemoveMyProjects(payload));
    };

    const getUpdatedSelectedProject = async (payload: ProjectDetails) => {
        return await dispatch(updateSelectedProject(payload));
    };

    const loadWellDetailsList = async (payload: WellDetailsPayload) => {
        return await dispatch(gettingWellDeatils(payload));
    }
    const updateExistingWell = async (payload: string) => {
        return dispatch(setExistingWellState(payload));
    }

    const loadCustomerDetailsList = async (payload: CustomerDetailsPayload) => {
        return await dispatch(gettingCustomerDetails(payload));
    }
    const updateExistingCustomer = async (payload: string) => {
        return dispatch(setExistingCustomerState(payload));
    }

    const updateCaseDetails = async (payload: { caseName: string, caseDescription: string, projectId: string }) => {
        return dispatch(patchCaseDetails(payload));
    }

    const createNewCase = async (payload: MyProjects) => {
        return dispatch(postCreateNewCase(payload));
    }

    const loadWellDeatilsById = async (payload: number) => {
        return await dispatch(gettingWellDetailsById(payload));
    }

    const loadCustomerDeatilsById = async (payload: number) => {
        return await dispatch(gettingCustomerDetailsById(payload));
    }
    const updateGlobalTemplate = async () => {
        return await dispatch(getGlobalTemplate());
    }
    const loadProjectStatus = () => {
        return dispatch(loadProjectStatusCount());
    };

    const fetchRecentCustomerFeedback = () => {
        return dispatch(loadRecentCustomerFeedback());
    };

    const getHasUserProjectAccess = (projectID: string) => {
        return dispatch(fetchHasUserProjectAccess(projectID));
    };

    return {
        loadProjects,
        loadPinProject,
        togglePinStatus,
        loadRecentProjects,
        loadOtherProject,
        copyMyProjects,
        copyMyProjectExists,
        removeMyProjects,
        getUpdatedSelectedProject,
        loadWellDetailsList,
        updateExistingWell,
        loadCustomerDetailsList,
        updateExistingCustomer,
        loadWellDeatilsById,
        loadCustomerDeatilsById,
        updateGlobalTemplate,
        updateCaseDetails,
        createNewCase,
        triggerUpdateProjectStatus,
        triggerShareWithCustomer,
        triggerGetSharedCases,
        loadProjectStatus,
        fetchRecentCustomerFeedback,
        getHasUserProjectAccess
    };
};

export default useProjectFacade;



